import { Link, useLocation } from 'react-router-dom';
import { ArrowLeft, Construction } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

function prettyName(path: string): string {
  const seg = path.replace(/^\//, '').split('/').filter(Boolean);
  return seg
    .map((s) =>
      s
        .split('-')
        .map((w) => w[0]?.toUpperCase() + w.slice(1))
        .join(' '),
    )
    .join(' · ');
}

export function ComingSoonPage() {
  const location = useLocation();
  const name = prettyName(location.pathname) || 'This module';

  return (
    <div className="mx-auto flex max-w-3xl flex-col items-center justify-center py-12 md:py-20">
      <Card className="w-full overflow-hidden">
        <div className="relative bg-gradient-to-br from-teal-700 via-teal-600 to-teal-800 p-8 text-white md:p-12">
          <div className="absolute -right-16 -top-16 h-56 w-56 rounded-full bg-amber-300/25 blur-3xl" />
          <div className="absolute -bottom-16 -left-10 h-56 w-56 rounded-full bg-teal-300/20 blur-3xl" />
          <div className="relative flex flex-col items-center text-center">
            <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-white/15 backdrop-blur-sm ring-1 ring-white/30">
              <Construction className="h-8 w-8" />
            </div>
            <h1 className="text-3xl font-bold tracking-tight md:text-4xl">{name}</h1>
            <p className="mt-3 max-w-md text-sm text-teal-100/90 md:text-base">
              This module is on the roadmap. We're building it carefully — clean architecture,
              proper permissions, and the same polish you see elsewhere.
            </p>
          </div>
        </div>

        <CardContent className="flex flex-col items-center gap-4 p-6 text-center md:p-8">
          <div className="flex items-center gap-2 rounded-full border border-amber-200 bg-amber-50 px-3 py-1 text-xs font-semibold text-amber-800">
            <span className="h-1.5 w-1.5 rounded-full bg-amber-500" />
            Planned · Not yet implemented
          </div>
          <p className="text-sm text-muted-foreground">
            Track development progress in the project roadmap.
          </p>
          <Button asChild variant="outline" className="gap-2">
            <Link to="/dashboard">
              <ArrowLeft className="h-4 w-4" />
              Back to Dashboard
            </Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
